import {
   randNumber,
   randBoolean,
   randFullName,
   randPersonTitle,
   randPhoneNumber,
   randEmail,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { Contact } from '../base';

export class MockContact extends Contact {
   constructor() {
      super();

      this.id = randNumber();
      this.pinned = randBoolean();
      if ( this.pinned && optional() ) { this.default = randBoolean(); }
      if ( optional() ) { this.name = randFullName(); }
      if ( optional() ) { this.title = randPersonTitle(); }
      if ( optional() ) { this.phone = randPhoneNumber(); }
      if ( optional() ) { this.email = randEmail(); }
   }
}
